import { render, staticRenderFns } from "./VerificationCodeForm.vue?vue&type=template&id=2cede538&scoped=true&"
import script from "./VerificationCodeForm.vue?vue&type=script&lang=js&"
export * from "./VerificationCodeForm.vue?vue&type=script&lang=js&"
import style0 from "./VerificationCodeForm.vue?vue&type=style&index=0&id=2cede538&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cede538",
  null
  
)

export default component.exports